module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-medium-dcb3da9eba3256ec8bb93ec1b45eb172.svg";